import React from 'react';
import { LandingPage } from './components/LandingPage';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <>
      <MetaPixel data-id="element-0" data-mp="35eemmx2prmbg" />
      <LandingPage data-id="element-1" data-mp="3k9kttndjpr6d" />
    </>;
}